/**
 * Constants for Ajustes component
 */

export const DEFAULT_CONFIG = {
  idioma: '2',
  zonaHoraria: '10',
  moneda: '3',
  isOpen: true,
  imprimirOrden: true,
  cajaPrincipal: '0',
  default_tip: '10',
} as const;

export const DROPDOWN_STYLES = {
  borderColor: 'transparent',
} as const;

export const MEDIO_PUNTO_APP_URL = 
  'https://mediopunto-bucket.s3.us-east-2.amazonaws.com/mp-downloable/MedioPuntoAppSetup.exe';
